// 头顶“云层”（精灵贴图 + 轻风移动 + 轻微起伏）
import * as THREE from 'three'

export function createClouds(scene, {
  around = null,         // 传 ddModel，便于确定中心
  count = 14,
  height = 80,           // 云层海拔
  spread = 320,          // 覆盖范围（正方形边长）
  baseSpeed = 0.25,      // 基础风速（X+ 方向）
  opacity = 0.85
} = {}) {
  const group = new THREE.Group()
  group.name = 'CloudsGroup'
  scene.add(group)

  // 计算中心（可用 ddModel 的包围盒中心）
  const center = new THREE.Vector3()
  if (around) {
    new THREE.Box3().setFromObject(around).getCenter(center)
  }

  // 生成一张“毛玻璃云朵”Canvas 纹理（免外部素材）
  const tex = (() => {
    const c = document.createElement('canvas'); c.width = 256; c.height = 128
    const ctx = c.getContext('2d'); ctx.clearRect(0, 0, 256, 128)
    for (let i = 0; i < 6; i++) {
      const x = 40 + i * 35 + Math.random() * 12
      const y = 60 + (Math.random() * 12 - 6)
      const r = 35 + Math.random() * 14
      const g = ctx.createRadialGradient(x, y, 6, x, y, r)
      g.addColorStop(0, 'rgba(255,255,255,0.9)')
      g.addColorStop(1, 'rgba(255,255,255,0)')
      ctx.fillStyle = g
      ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.fill()
    }
    const t = new THREE.CanvasTexture(c)
    t.generateMipmaps = true
    t.anisotropy = 2
    return t
  })()

  const sprites = []
  for (let i = 0; i < count; i++) {
    const sp = new THREE.Sprite(new THREE.SpriteMaterial({
      map: tex, transparent: true, depthWrite: false, opacity
    }))
    sp.scale.set(30 + Math.random() * 40, 15 + Math.random() * 12, 1)
    sp.position.set(
      center.x + (Math.random() - 0.5) * spread,
      height + Math.random() * 20,
      center.z + (Math.random() - 0.5) * spread
    )
    sp.userData.vx = baseSpeed * (0.6 + Math.random() * 0.8) // 0.15~0.45
    sp.userData.phase = Math.random() * Math.PI * 2
    sprites.push(sp)
    group.add(sp)
  }

  function update(delta, elapsed = 0) {
    let moved = false
    for (const sp of sprites) {
      const p = sp.position
      p.x += sp.userData.vx * delta * 30
      // 轻微上下起伏
      p.y += Math.sin(elapsed + sp.userData.phase) * 0.015
      // 出界从左侧回卷
      if (p.x > center.x + spread * 0.5) {
        p.x = center.x - spread * 0.5
        p.z = center.z + (Math.random() - 0.5) * spread
      }
      moved = true
    }
    return moved
  }

  function dispose() {
    scene.remove(group)
    group.traverse(o => {
      if (o.material?.map) o.material.map.dispose?.()
      o.material?.dispose?.()
      o.geometry?.dispose?.()
    })
  }

  return { group, update, dispose }
}
